import React from 'react';

const Testimonials = () => {
  const testimonials = [
    { name: 'Meet Shah', role: 'Founder, Vraj Technologies', text: 'BuzzMinded transformed our online presence. Our lead generation has increased by 150% in just 3 months. Fantastic work!', avatar: 'bg-gradient-to-r from-cyan-400 to-blue-500' },
    { name: 'Priya Desai', role: 'Marketing Head, Shreeji Retail', text: 'The level of professionalism and the results delivered are outstanding. They truly care about your success and growth.', avatar: 'bg-gradient-to-r from-purple-400 to-pink-500' },
    { name: 'Parth Patel', role: 'Director, Patidar Real Estate', text: 'Their data-driven approach means every decision is backed by numbers. We finally understand our ROI properly.', avatar: 'bg-gradient-to-r from-yellow-400 to-orange-500' }
  ];

  return (
    <section id="testimonials" className="testimonials-section">
      <div className="container">
        <div className="section-header text-center">
          <h2 className="section-title">What Our Clients Say</h2>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((test, index) => (
            <div key={index} className="testimonial-card">
              <div className="stars">★★★★★</div>
              <p className="testimonial-text">"{test.text}"</p>
              <div className="testimonial-author">
                <div className={`testimonial-avatar ${test.avatar}`}></div>
                <div>
                  <h4 className="author-name">{test.name}</h4>
                  <p className="author-role">{test.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
